import { AdBuilder } from "../../../Marketing/AdBuilder/index.js";
async function AdBuilderFlyout({
  entry,
  locale,
  sx
}) {
  if (!entry) {
    console.error("AdBuilderFlyout error: Invalid entry.");
    return null;
  }
  const { uid } = entry.ad_builder_reference[0];
  return await AdBuilder({ entryId: uid, locale, sx });
}
export {
  AdBuilderFlyout
};
